import { Resource } from '@thiememeulenhoff/types';

export type ResourceWithGroup = Resource & { groupIdentifier: string | null };

// A questionGroup is not itself scoreable/navigable, so its questions are
// hoisted up to become the actual items. Each hoisted question keeps track
// of its enclosing group's identifier so callers can navigate to the group
// as a whole instead of the question directly.
export function collectQuestionsByParentId(
  parentId: string,
  resources: Array<Resource>,
  groupIdentifier: string | null = null,
): Array<ResourceWithGroup> {
  return resources.flatMap((resource) => {
    if (resource.parentIdentifier !== parentId) {
      return [];
    }

    if (resource.digitalResourceType === 'question') {
      return [{ ...resource, groupIdentifier }];
    }

    if (resource.digitalResourceType === 'questionGroup') {
      return collectQuestionsByParentId(
        resource.contentIdentifier,
        resources,
        resource.contentIdentifier,
      );
    }

    return [];
  });
}
